import Api from '@/api/api'

export default {
    getFeature() {
        return Api.get('SaasAdmin/Feature/GetFeatures')
    },
    getFeatureById(id) {
        return Api.get('SaasAdmin/Feature/GetFeatureById?id=' + id)
    },
    addFeature(data) {
        return Api.post('SaasAdmin/Feature/AddFeature', data)
    },
    updateFeature(id, data) {
        return Api.put('SaasAdmin/Feature/UpdateFeature?id=' + id, data)
    },
    removeFeature(id) {
        return Api.delete('SaasAdmin/Feature/DeleteFeature?id=' + id)
    }
}